<template>
  <div class="player-wrapper">
    <audio
      v-if="showAudioPlayer"
      @ended="onEnded"
      @timeupdate="onTimeUpdate"
      @seeking="onSeeking"
      ref="audio"
      controls
    >
      <source :src="f" v-for="(f, idx) in sources" :key="`src-${idx}`" />
      {{ $t("Audio tag not supported") }}
    </audio>
    <span v-if="showAudioPlayer" class="plays-left"
      >Playbacks left: {{ maxPlayCount - playedCounter }}&times;</span
    >
    <slot v-else name="maxPlaybacksReached">{{
      $t("Test audio max. playbacks reached")
    }}</slot>
  </div>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    name: { type: String },
    sources: {
      type: Array
    },
    maxPlayCount: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      playedCounter: 0,
      supposedTime: 0
    };
  },
  computed: {
    showAudioPlayer() {
      return this.maxPlayCount <= 0 || this.maxPlayCount > this.playedCounter;
    }
  },
  methods: {
    onEnded() {
      this.playedCounter += 1;
      this.supposedTime = 0;
      if (this.playedCounter >= this.maxPlayCount) {
        this.$emit("playbacksMax", this);
      }
    },
    onTimeUpdate() {
      let media = this.$refs.audio;
      if (!media.seeking) {
        this.supposedTime = media.currentTime;
      }
    },
    onSeeking() {
      let media = this.$refs.audio;
      var delta = media.currentTime - this.supposedTime;
      delta = Math.abs(delta); // disables seeking backwards
      if (delta > 0.01) {
        media.currentTime = this.supposedTime;
      }
    }
  }
};
</script>

<style lang="scss">
.player-wrapper {
  display: flex;
  flex-direction: column;
  margin: 0 15px;
  position: relative;
  .plays-left {
    display: flex;
    align-self: flex-end;
    position: absolute;
    font-size: 0.85em;
    top: 100%;
  }
}
</style>
